import { WidgetBase } from '../models';
import { Helper } from '../../common';

import { alarmsGaugesWidgetDefinition as definition } from '../../widgets/widgets.definition.index';

export class AlarmsGaugesWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    configuration = {};
    guid: string;
    hasExtendedProperties = false;
    highlights = definition.highlights;
    icon = definition.icon;
    name = definition.title;
    row = 0;
    sizeX = 6;
    sizeY = 12;
    type = definition.type;

    constructor() {
        super();
        this.guid = Helper.getGuid();
    }
}
